import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'

import AddBlockedDomainDialog from './components/AddBlockedDomainDialog'
import BlockedDomainsTable from './components/BlockedDomainsTable'

import styles from './BlockedDomainsTab.module.scss'

import { getBlockedDomains } from '@/api/internal'

export const BLOCKED_DOMAINS_QUERY_KEY = ['blockedDomains'] as const

const BlockedDomainsTab = () => {
  const [isAdding, setIsAdding] = useState(false)

  const {
    data: domains = [],
    isLoading,
    error,
  } = useQuery({
    queryKey: BLOCKED_DOMAINS_QUERY_KEY,
    queryFn: async () => {
      const response = await getBlockedDomains()
      return response.data.blocked_domains ?? []
    },
  })

  const handleSave = () => {
    setIsAdding(false)
  }

  return (
    <div className={styles.content}>
      {error && <div className={styles.errorBanner}>Failed to load blocked domains</div>}

      <BlockedDomainsTable domains={domains} isLoading={isLoading} onAdd={() => setIsAdding(true)} />

      <AddBlockedDomainDialog isOpen={isAdding} onSave={handleSave} onCancel={() => setIsAdding(false)} />
    </div>
  )
}

export default BlockedDomainsTab
